import { RcClasses } from '../../../foundation';
var RcRatingClasses = RcClasses([
    'readOnly',
    'disabled',
    'focusVisible',
    'pristine',
    'label',
    'icon',
    'iconEmpty',
    'iconFilled',
    'iconActive',
], 'RcRating');
export { RcRatingClasses };
